var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 46.21 114.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".e{fill:#ef8f71;}.f,.g{fill:#c59571;}.h,.i{fill:#754a48;}.j{fill:url(#c);}.j,.k{opacity:.47;}.j,.k,.l,.m,.n,.i,.g,.o,.p,.q,.r{fill-rule:evenodd;}.j,.k,.l,.m,.r{mix-blend-mode:multiply;}.k{fill:url(#d);}.l{fill:url(#b);}.l,.m{opacity:.39;}.m{fill:#528124;}.n{fill:#f7dfd8;}.o{fill:#925f5d;}.p{fill:#8fc296;}.q{fill:#fff;}.r{fill:#cf9b9b;opacity:.38;}.s{isolation:isolate;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -4.26,
    y1: 50.81,
    x2: 8.35,
    y2: 48.23,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#617201"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#aba700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 17.26,
    y1: 105.87,
    x2: -8.63,
    y2: 106.28,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d7aab8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a74057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 17.25,
    y1: 105.05,
    x2: -8.64,
    y2: 105.45,
    xlinkHref: "#c"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28.04,50.38l11.1-28.63s-8.83,2.3-10.44,14.76-.66,13.88-.66,13.88Z",
    style: {
      fill: "#8fc296",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M31.38,36.96c-.01,.07-.02,.14-.03,.21-1.43,10.91-9.68,28.5-14.26,25.17-3.65-2.66-5.64-23.35-2.98-35.08,.24-.67,.51-1.33,.79-2,.72-1.69,1.45-3.27,2.18-4.77h.01C24.3,5.82,31.87,0,32.79,0c.69,0,.43,21.26-1.4,36.96Z",
    style: {
      fill: "#8fc296",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.36,65.93l13.54-10.35c-.31,.43-10.36,14.16-16.25,15.15-5.97,1.01-19.1,0-19.1,0C-.56,59.61,6.52,25.26,6.52,25.26l4.83,26.21c-.62-6.81-.41-15.64,2.77-24.21-2.66,11.73-.66,32.42,2.98,35.08,4.58,3.33,12.82-14.26,14.26-25.17-.39,3.33-.41,6.68-.48,9.53,5.15-10.98,10.96-22.89,13.02-25.48,3.1-3.88,3.23,16.62-.54,29.57-1.13,3.94-2.64,7.17-4.51,8.82-3.28,2.87-5.73,4.91-7.49,6.31Z",
    style: {
      fill: "#8fc296",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9,55.58c-.31,.42-10.36,14.16-16.25,15.15-4.44,.75-12.83,.38-16.85,.15-1.38-.08-2.25-.15-2.25-.15C-.55,59.61,6.52,25.26,6.52,25.26l4.83,26.21c-.11-1.17-.19-2.4-.22-3.68-.23-6.16,.36-13.44,2.99-20.53-2.66,11.73-.67,32.42,2.98,35.08,4.58,3.33,12.82-14.26,14.26-25.17,.01-.07,.02-.14,.03-.21,1.42-10.4,6.06-13.95,6.36-14.17-.17,.49-5.99,16.29-8.72,27.89-1.49,6.32-2.05,11.41-.28,12.07,3.66,1.38,9.91-3.44,14.63-11.96-1.13,3.94-2.64,7.17-4.52,8.82-3.28,2.87-5.73,4.91-7.49,6.31l13.54-10.35Z",
    style: {
      fill: "#528124",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.39
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.29,70.51c-.13,.16-.29,.28-.48,.36-1.38-.08-2.25-.15-2.25-.15C-.55,59.61,6.52,25.26,6.52,25.26l4.83,26.21c-.11-1.17-.19-2.4-.22-3.68,1.42,11.11,2.35,21.31,1.16,22.72Z",
    style: {
      fill: "url(#b)",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.39
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "40.44 68.4 40.1 72.49 40.02 73.51 39.88 75.29 39.81 76.13 39.65 77.93 39.48 80.01 39.12 84.38 38.71 89.46 37.76 100.88 37.73 101.13 37.72 101.36 37.57 103.13 37.5 104 37.35 105.85 5.36 105.85 5.07 103.15 5.07 103.14 5.06 103.13 4.83 101.11 2.89 83.48 2.23 77.47 1.93 74.82 1.84 73.93 1.23 68.4 40.44 68.4",
    style: {
      fill: "#925f5d",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.65 77.93 39.48 80.01 39.12 84.38 7.46 83.6 2.89 83.48 2.23 77.47 5.2 77.52 39.65 77.93",
    style: {
      fill: "#f7dfd8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.02 73.51 39.88 75.29 4.58 74.84 1.93 74.82 1.84 73.93 4.4 73.9 40.02 73.51",
    style: {
      fill: "#f7dfd8",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.76,101.13l-.04,.23-.29,1.77-.14,.91-.29,1.8-.06,.35-1.73-.02-11.4-.12-3.76-.05-5.41-.06h-.44l-1.9-.02-5.54-.07h-1.4l-.29-2.7h0v-.02l-.23-2.02-1.94-17.63-.66-6-.3-2.66-.09-.89-.61-5.52H3.92c-.01,1.5,.12,3.38,.48,5.5,.05,.3,.11,.62,.18,.94,.16,.87,.36,1.77,.62,2.68,.53,1.97,1.26,4.03,2.26,6.07,4.06,8.46,12.43,16.75,28.91,17.49h.01c.44,.02,.9,.03,1.36,.05h.02Z",
    style: {
      fill: "#cf9b9b",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.38
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.45,69.28s2.4,1.22,4.22,.81c1.83-.41,2.13-.81,2.13-.81h-6.36Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 103.13,
    width: 42.1,
    height: 5.8,
    style: {
      fill: "#ef8f71"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "6.77 101.25 6.77 114.15 3.01 114.15 2.1 100.9 6.77 101.25",
    style: {
      fill: "#c59571",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "40.07 100.55 38.97 114.78 35.21 114.78 35.21 101.24 40.07 100.55",
    style: {
      fill: "#c59571",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.05,
    y: 101.89,
    width: 3.75,
    height: 12.89,
    style: {
      fill: "#c59571"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.73,
    y: 108.94,
    width: 4.1,
    height: 1.67,
    style: {
      fill: "#754a48"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.11,
    y: 108.94,
    width: 3.75,
    height: 1.67,
    style: {
      fill: "#754a48"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.42 108.94 39.29 110.6 35.27 110.6 35.27 108.94 39.42 108.94",
    style: {
      fill: "#754a48",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.77,108.94H1.73l-.37-5.8H11.87c.29,1.87,.72,4.62,.89,5.8Z",
    style: {
      fill: "url(#c)",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.47
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55,107.04c.04,.3-.66-2.1-1.18-3.91h1.59c-.23,1.9-.44,3.69-.41,3.91Z",
    style: {
      fill: "url(#d)",
      fillRule: "evenodd",
      mixBlendMode: "multiply",
      opacity: 0.47
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4.54 103.13 36.42 104.2 42.36 103.13 4.54 103.13",
    style: {
      fill: "#c59571",
      fillRule: "evenodd"
    }
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlant);
export default __webpack_public_path__ + "static/media/plant.5dd7bbc979123786156eb4dcf2b3dcc9.svg";
export { ForwardRef as ReactComponent };